<app-selector label="Company" [isEmptySelectable]="false" [data]="companyCoreService.companyList$ | async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="companyCoreService.loading" [hint]="hint">
</app-selector>